$(window).load(function() {
  console.log('window load');
  $(".fs-slider_v2_5 .fs-wrapper .fs-timeline-entry").click(function(){
    console.log('open video popup');
    var myVar = setInterval(myTimer, 500);
    function myTimer() {
      if( $('.fs-slider_v2_5 .fs-detail-outer-container').length ) {
        $('.fs-slider_v2_5 .fs-detail-outer-container video').get(0).play();
        clearInterval(myVar);

        $(".fs-slider_v2_5 .fs-detail-container .fs-detail-nav-button").click(function(){
          console.log('click nav open video popup');
          var myVar = setInterval(myTimer, 500);
          function myTimer() {
            if( $('.fs-slider_v2_5 .fs-detail-outer-container video').length ) {
              $('.fs-slider_v2_5 .fs-detail-outer-container video').get(0).play();
              clearInterval(myVar);
            }
          }
        });
        
      }
    }
  });
  
 
});

function isValidEmailAddress(emailAddress) {
  var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
  return pattern.test(emailAddress);
}

function register($form) {
  $.ajax({
    type: 'POST',
    url: '//lasaona.com/pilgrimclothing/generate_discount/call-action.php',
    data: {"email":$form.find('input[type=email]').val(),"type":"welcome"},
    dataType : 'json',
    encode : true,
    error       : function(err) {
      $("#ajax2").css('color','red');
      $("#ajax2").html("Could not connect to the registration server. Please try again later.");
    },
    success     : function(result) {
      if(result.success){
        $.ajax({
          type: $form.attr('method'),
          url: $form.attr('action'),
          data: $form.serialize()+'&COUPON='+result.message,
          cache       : false,
          dataType    : 'json',
          contentType: "application/json; charset=utf-8",
          error       : function(err) { 
            $("#ajax2").css('color','red');
            $("#ajax2").html("Could not connect to the registration server. Please try again later.");
          },
          success     : function(data) {
            if (data.result != "success") 
            {
              if (data.msg.indexOf("is already subscribed") >= 0)
              {
                var text_msg = data.msg.split('is already subscribed to list Pilgrim Clothing');
                $("#ajax2").css('color','red');
                $("#ajax2").html('<a style="color:#0000FF;text-decoration: underline;cursor: pointer;">'+ data.msg+'</a>');
              }
              else
              {    
                $("#ajax2").css('color','red');
                $("#ajax2").html(data.msg);
              }            
            } 
            else 
            {
              $("#thankyou_pop").css("display",'block');
              $("#close-form").css("display",'none');
            }
          }
        });
      }else{
        $("#ajax2").css('color','red');
        $("#ajax2").html("Your email has been received the code in the past.");
      }
    }
  });
}

function register_mailchimp($form) {
    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache       : false,
      dataType    : 'json',
      contentType: "application/json; charset=utf-8",
      error       : function(err) { 
        $("#ajax").css('color','red');
        $("#ajax").html("Could not connect to the registration server. Please try again later.");
      },
      success     : function(data) {
        if (data.result != "success") 
        {
          if (data.msg.indexOf("is already subscribed") >= 0)
          {
            var text_msg = data.msg.split('is already subscribed to list Pilgrim Clothing') 
            $("#ajax").css('color','red');
            $("#ajax").html('<a style="text-decoration: underline;cursor: pointer;">'+ text_msg[0]+'</a> is already subscribed');
          }
          else
          {    
            $("#ajax").css('color','red');
            $("#ajax").html(data.msg);
          }            
        } 
        else 
        {
          $("#ajax").css('color','green');
          $("#ajax").html("Thank you for subscribing, your discount has been sent to your inbox!");
        }
      }
    });
  }


var myVarSee = setInterval(myTimerSee, 500);
function myTimerSee() {
  if( $('tolstoy-stories .tolstoy-stories-main-container').length ) {
    console.log('has tolstoy-stories');
    $('.js-popup-button-see-it').addClass('active');
    clearInterval(myVarSee);
  }
}

var myVarIchange = setInterval(myTimerIChange, 500);
function myTimerIChange() {
  if( $('.iChangeApp--modal').length ) {
    console.log('has iChangeApp--modal');
    $('.iChangeApp--modal #ica--modal-emails').prop('checked', false);
    clearInterval(myVarIchange);
  }
}


$(document).ready(function(){

   $(".js-popup-button-see-it").click(function(){
    console.log('222 it');
    //window.tolstoyWidget.recreate('vamb43jdtmq90');
    //window.tolstoyWidget.show();
    console.log($('tolstoy-stories a').text());
    $('a[data-tolstoy-element="tolstoy-stories-on-you-button-vamb43jdtmq90"]').click();
    $("tolstoy-stories a")[0].click();
    $('tolstoy-stories a').trigger('click');

    window.tolstoyWidget.start();
    window.tolstoyWidget.vamb43jdtmq90.init();
  });
  
  /* iequalchange */
  if ($('#i-change').length > 0) {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        var obj = JSON.parse(xhttp.response);
        console.log(obj);
        document.getElementById("raised-total").innerHTML = "$" + obj.donation;	 
      }
    };
    var url = "https://share.iequalchange.com/public/api/donations/livetotal?logo=1";
    xhttp.open("GET", url, true);   // async
    xhttp.setRequestHeader ("Authorization", "Basic NDk2Oj9lXEZBR353MiRjdS42YXQ=");
    xhttp.setRequestHeader ("Accept", "*/*");
    xhttp.send();
  }

  /* gift card page */
  if ($('#gift-card-page').length > 0) {
    console.log('gift card page');
      
  }
  
  /*START CUSTOM JS*/
  console.log($('#slide_home').length);
  if($('#slide_home').length > 0){
    $('#slide_home').owlCarousel({
      autoplay:true,
      autoplayTimeout:10000,
      loop:true,
      margin:10,
      nav:true,
      dots: true,
      responsive:{
        0:{
          items:1
        },
        600:{
          items:1
        },
        1000:{
          items:1
        }
      }
    })

    $('#slide_mb').owlCarousel({
      autoplay:true,
      autoplayTimeout:10000,
      loop:true,
      margin:10,
      nav:true,
      dots: false,
      responsive:{
        0:{
          items:1
        },
        600:{
          items:1
        },
        1000:{
          items:1
        }
      }
    })
  }


  setTimeout(function() {
    $('#slider_home-hero').owlCarousel({
    autoplay:false,
    autoplayTimeout:4000,
    loop:true,
      mouseDrag:false,
    nav:false,
    dots: false,
       touchDrag: false,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:1
      },
      1000:{
        items:1
      }
    }
  })
},1000);
  
  /* Newsletter Form */
  var $form = $('#mc-embedded-subscribe-form');
    $('.newsletter').click(function(){
      var validEmail = isValidEmailAddress($('#mail').val());
      if(validEmail)
      {
        $("#ajax").html("");
        $(".wrrap-loading").show();
        
        var email = $('#mail').val();
        var type = 'welcome';
        var postData = {
              "email":email,
              "type":type
            }
        $.ajax({
          type      : 'POST',
          url		: 'https://lasaona.com/pilgrimclothing/generate_discount/call-action.php?email='+email+'&type='+type,
          data      : postData,
          dataType  : 'json',
          encode    : true,
          success: function( data, textStatus, jQxhr ){
            //console.log( data );
          },
          error: function( jqXhr, textStatus, errorThrown ){
            console.log( errorThrown );
            $("#ajax").css('color','red');
        	$("#ajax").html("Could not connect to the registration server. Please try again later.");
            $(".wrrap-loading").hide();
          }
        }).done(function(data) {
			$('#generate-coupon').val(data.message);
            $(".wrrap-loading").hide();
          	setTimeout(function(){ register_mailchimp($form); }, 250);
        }); 
        
      }else{
        $("#ajax").html("Please enter a valid email address");
        $('#mail').focus();
      }
      return false;
    });
  
  /* Popup Subscription */
  var $form2 = $('#mc-embedded-subscribe-form2');

  $form2.find('input[type=button]').click(function(){
    if($form2.find('input[type=email]').val() != ""){
      $("#ajax2").html("");
      register($form2);
    }else{
      $("#ajax2").html("Please enter a valid email address");
      $('#PopupSubscribe').focus();
    }
    return false;
  });
  
  /* Contact Page */
  console.log($('#contact-us').length);
  if($('#contact-us').length > 0){
    $('#subject').fancySelect({
      showText: true,
      showImages: false
    });

    var mySelect = $('#subject');
    var subject = $(this).val();

    mySelect.fancySelect().on('change.fs', function() {
      $(this).trigger('change.$');
      var subject = $(this).val();
      $(".trigger").removeClass("required");
      if(subject == "Stock Enquiries"){
        $('#stock-enquiries').addClass("show");
        $('.trigger.selected').addClass("show");
      }else{
        $('#stock-enquiries').removeClass("show");
        $(".trigger.selected").removeClass("show");
      }
    }); // trigger the DOM's change event when changing FancySelect

    var isMobile = navigator.userAgent.match(/iPad|iPhone|Android|Blackberry/i);
    if(isMobile){
      $('#contact_form').append( '<input type="hidden" name="contact[mobile]" value="1" />' );
    }


    $('#contact_form').submit(function(e) {

      e.preventDefault();

      var mySelect = $('#subject');
      var subject = $(this).val();      

      mySelect.fancySelect().on('change.fs', function() {
        $(this).trigger('change.$');
        var subject = $(this).val();
        $(".trigger").removeClass("required");
        if(subject == "Stock Enquiries"){
          $('#stock-enquiries').addClass("show");
          $('.trigger.selected').addClass("show");
        }else{
          $('#stock-enquiries').removeClass("show");
          $(".trigger.selected").removeClass("show");
        }
      });

      var subject = $('#subject').val();
      if(subject == ""){

        $(".trigger").addClass("required");
        return false;

      }else{

        $(".trigger").removeClass("required");
        //this.submit(); // use the native submit method of the form element

        $form = $(this);      
        var formData = $form.serialize();
        console.log(formData);
        $form.find('.submit_btn').attr("disabled","disabled").val('SENDING...'); 
        $.ajax({
          type      : 'POST',
          url		: 'https://lasaona.com/pilgrimclothing/submit.php?function=contact-form',
          data      : formData,
          dataType  : 'json',
          encode    : true
        }).done(function(data) {
          if(data.success){
            document.getElementById("contact_form").reset();
            $('.response-messenger').show();

          }else{
            alert(data.message);
          }
          $form.find('.submit_btn').removeAttr("disabled").val('SEND ENQUIRY');
        });

      }

    });
  }
    

    $(".footer__menus li.has-dropdown span").click(function () {
      console.log('222');
      $this = $(this);
  	  $target =  $this.next();
      if($target.hasClass('active')){
        $target.removeClass('active').slideUp(300);
      } else {
        $target.addClass('active').slideDown(300); 	 
      }
    });
  

});

$('.tabs__content.prdDescr').html(function(i,h){
    return h.replace(/&nbsp;/g,'');
});


$(function () {

  $(".subsub-dropdown").css("display", "none");
 
  $(".sub_link_custom").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });
});

 $(document).ready(function() {
    $(window).scroll(function() {
        $(".announcement__bar-new").addClass("active");
        var scroll = $(window).scrollTop();
 
        if (scroll <= 10) {
          $(".announcement__bar-new").removeClass("active");
        }
      });
  });
  /*END CUSTOM JS*/